import { addErrorNotification, addSuccessNotification, NotificationType, reactivateCurrentMemberSubscription } from '@vista/omnichannel-components-domain';
import { getIdForComponentNotification } from '../../../utils/get-id-for-component-notification';
export const reactivateSubscription = async (displayText) => {
    const { reactivateSubscriptionSucceededMessage, reactivateSubscriptionFailedMessage } = displayText;
    try {
        await reactivateCurrentMemberSubscription();
        addSuccessNotification({
            id: getIdForComponentNotification('member-payment-card-wallet', NotificationType.Success, 'reactivate-subscription'),
            messages: [reactivateSubscriptionSucceededMessage]
        });
    }
    catch (error) {
        addErrorNotification({
            id: getIdForComponentNotification('member-payment-card-wallet', NotificationType.Error, 'reactivate-subscription'),
            messages: [reactivateSubscriptionFailedMessage]
        }, error);
    }
};
